import { TMessage, TMessageSchema } from '../../types/messages';
import { mapMessageToDeleted } from './mapMessageToDeleted';
import { mapMessageToOutgoing } from './mapMessageToOutgoing';
import { mapMessageToIncoming } from './mapMessageToIncoming';

/**
 * @description
 * Обновляет существующее сообщение данными из rawMessage.
 *
 * @param existingMessage - существующее сообщение в UI
 * @param rawMessage - сообщение с бэкенда
 * @returns обновлённое сообщение для UI
 */
export function updateMessageFromRaw(existingMessage: TMessage, rawMessage: TMessageSchema): TMessage {
  const { status: rawMessageStatus } = rawMessage;
  const { isOutcoming } = existingMessage;

  if (rawMessageStatus === 'deleted') {
    return mapMessageToDeleted(existingMessage, rawMessage);
  }

  if (isOutcoming) {
    return mapMessageToOutgoing(existingMessage, rawMessage);
  }

  return mapMessageToIncoming(existingMessage, rawMessage);
}
